import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { SalesRepDropdown } from "./sales-rep-dropdown";
import styles from "./asign-modal.module.scss";
import CrossIcon from "../../../../../icons/cross.icon";

export const AssignModal = ({ show = false, onHide, onSave }) => {
  const [selectedSalesRep, setSelectedSalesRep] = useState("Ellie James");

  const handleSave = () => {
    if (selectedSalesRep) {
      if (onSave) {
        onSave(selectedSalesRep);
      }
      console.log("Save assignment:", selectedSalesRep);
      onHide();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName="assign-modal-dialog"
      className={styles.modal}
      aria-labelledby="assign-modal"
    >
      <Modal.Header className={styles.headerContainer}>
        <div className={styles.headerContent}>
          <div className={styles.closeButtonWrapper}>
            <button
              className={styles.closeButton}
              onClick={onHide}
              type="button"
              aria-label="Close dialog"
            >
              <CrossIcon fill="#616778" width={10} height={10} />
            </button>
          </div>

          <div className={styles.titleWrapper}>
            <div className={styles.title} id="assign-title">
              Assign
            </div>
          </div>
        </div>

        <div className={styles.dividerWrapper}>
          <div style={{ borderTop: "1px solid rgba(235, 237, 241, 1)", width: "100%" }} />
        </div>
      </Modal.Header>

      <Modal.Body className={styles.content}>
        <p className={styles.description}>
          Select the Sales Rep you want to assign this accounts to
        </p>

        <div className={styles.salesRepContainer}>
          <label htmlFor="sales-rep-select" className={styles.salesRepLabel}>
            Sales Rep
          </label>

          <SalesRepDropdown
            id="sales-rep-select"
            value={selectedSalesRep}
            onChange={setSelectedSalesRep}
          />
        </div>
      </Modal.Body>

      <Modal.Footer className={styles.footer}>
        <div className={styles.footerContent}>
          <button
            className={styles.cancelButton}
            onClick={onHide}
            type="button"
          >
            Cancel
          </button>
          <div className={styles.buttonGroup}>
            <button
              className={styles.saveButton}
              onClick={handleSave}
              type="button"
            >
              Save
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
